import React from 'react';
import { API } from 'aws-amplify';
import { Row, Col, Button, Table } from 'reactstrap';
import './Appointments.css';
import Icon from '@mdi/react';
import { mdiDeleteForever, mdiCalendar } from '@mdi/js';
import { Link } from 'react-router-dom';
import AddToCalendar from 'react-add-to-calendar';
import { getAppointmentTableHeader } from './AppointmentTableConfig';
var serviceNames = require('../ServiceNameMapper');

const moment = require('moment-timezone');
var timer = '';
let order = 'desc';
class AppointmentsList extends React.Component {
    constructor(props) {
        const displayName = 'Example';

        super(props);
        var attendeetype = '';
        if (global.$attendeetype == null) {
            //console.log("null")
            attendeetype = "Attendee"
        }
        else {
            attendeetype = global.$attendeetype
        }

        this.state = {
            code: global.$code,
            s3: global.$s3,
            bucket: global.$s3bucket,
            appointments: '',
            showtable: true,
            attendeetype: attendeetype
        };
        timer = setInterval(() => {
            this.getAppointments()
        }, 1000)
        this.idFormatter = this.idFormatter.bind(this);
    }

    componentDidMount() {
        this.tableHeaderColumn = getAppointmentTableHeader(this.state.attendeetype);
    }

    deleteAppointment(exhibitor) {
        let apiName = serviceNames.getAppointmentService();
        let path = ''; //replace this with the path you have configured on your API
        var cancelfrom = ' ';
        if(global.$attendeetype.includes("Delegate"))
        {
            cancelfrom = global.$userid;
        }
        if(global.$attendeetype.includes("Exhibitor"))
        {
            cancelfrom = exhibitor.userid.S;
        }
        let myInit =
        {
            body:
            {
                'code': this.state.code,
                'command': "addAppointment",
                'id': exhibitor.id.S,
                'begintime': exhibitor.begintime.S,
                'endtime': exhibitor.endtime.S,
                'ownerid': exhibitor.ownerid.S,
                'ownername': exhibitor.ownername.S,
                'userid': " ",
                'username': " ",
                'status': "A",
                'meeting': exhibitor.meeting.S,
                'notes': exhibitor.notes.S,
                'data1': exhibitor.data1.S,
                'data2': exhibitor.data2.S,
                'data3': exhibitor.data3.S,
                "appointmentstatus": "cancel",
                "cancelfrom": cancelfrom
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
        //console.log(myInit);
        API.post(apiName, path, myInit).then(response => {
            ////console.log (response.data);
            this.getAppointments();
            this.setState({ dataloaded: true });
        }
        ).catch(error => {
            ////console.log(error.response)
        });
    }

    idFormatter(cell) {
        //console.log(cell);
        var bdate = moment(cell.begintime.S).format();
        var edate = moment(cell.endtime.S).format();
        //console.log(bdate,edate);
        let icon = { 'calendar-plus-o': 'left' };
        let items = [
            { apple: 'Apple' },
            { google: 'Google' },
            { outlook: 'Outlook' },
            { yahoo: 'Yahoo!' }
        ];
        var calender = {
            title: 'Appointment',
            description: cell.notes.S,
            location: global.$settings.timezone,
            startTime: bdate,
            endTime: edate
        }
        //console.log(calender);
        return (<div>
            <Row>
                <Col md={3}>
                    <Link to="#" onClick={() => { if (window.confirm(`Do you wish to cancel this appointment?`)) { this.deleteAppointment(cell) }; }}><Icon path={mdiDeleteForever} size={1} color="gray" /></Link>
                </Col>
                <Col md={9}>
                    <AddToCalendar
                        event={calender}
                        buttonLabel=""
                        buttonTemplate={icon}
                        listItems={items}
                        displayItemIcons={false}>
                    </AddToCalendar>
                </Col>
            </Row>
        </div>)
    }

    render() {

        if (this.state.dataloaded) {
            //console.log(this.state.attendeetype, this.state.showtable)
           

            return (
                <div className="appointment-div" >
                    <div>
                        <br />
                        <div className="appointments-header">
                            Available Appointments
                            <hr className="appointment-hr" />
                        </div>
                        <Row>
                            <Col md={10} className="offset-md-1">
                                {
                                    this.state.showtable ?
                                        (
                                            <Table bordered responsive className="reactstrap-table">
                                                <thead>
                                                <tr>
                                                    {
                                                        this.tableHeaderColumn.map((header) => {
                                                          return(
                                                            <th style={header.headerStyle}>{header.text}</th>
                                                          )
                                                        })                                                                                            
                                                    }
                                                </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.appointments.map((item) => {
                                                            return(
                                                                <tr className='table-body'>
                                                                    <td>{this.idFormatter(item.id)}</td>
                                                                    {
                                                                        this.state.attendeetype == "Exhibitor"
                                                                        ?
                                                                        <>
                                                                        <td>{item.username}</td>
                                                                        <td>{item.userid}</td>                                                                        
                                                                        </>
                                                                        :
                                                                        <>
                                                                        <td>{item.ownername}</td>
                                                                        <td>{item.ownerid}</td>                                                                        
                                                                        </>
                                                                    }
                                                                    <td>{item.begintime}</td>
                                                                    <td>{item.endtime}</td>
                                                                    <td>{item.meeting}</td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>                                                                
                                            </Table>
                                        )
                                        :
                                        (
                                            <dvi className="appointments-no-data offset-md-5">
                                                You don't have any appointments
                                            </dvi>
                                        )
                                }
                            </Col>
                        </Row>

                    </div>
                </div>
            )
        }
        else {
            this.getAppointments();
            return (
                <div>
                    <Row>
                        <Col md={6} className="offset-5">
                            <div className="loading-div">
                                <div className="loading-text">Loading....</div>
                            </div>
                        </Col>
                    </Row>
                </div>
            )
        }
    }

    getAppointmentTableObjects(objs) {
        //console.log(objs);
        const tableObjs = []

        for (var i = 0; i < objs.length; i++) {
            var Obj = objs[i]
            //console.log(Obj);
            var newObj = Object()

            //console.log(this.state.attendeetype);
            ///console.log(global.$attendeetype);
            //console.log(Obj.ownerid.S, global.$userid)
            if (this.state.attendeetype.includes("Exhibitor")) {
                if (Obj.ownerid.S == global.$userid) {
                    //console.log("exhibitor")
                    this.state.showtable = true;

                    newObj.id = Obj
                    newObj.begintime = Obj.begintime.S
                    newObj.endtime = Obj.endtime.S
                    newObj.userid = Obj.userid.S
                    newObj.username = Obj.username.S
                    newObj.meeting = Obj.meeting.S
                    tableObjs.push(newObj);
                    //console.log(tableObjs);
                }
            }
            else if (this.state.attendeetype.includes("Attendee")) {
                //console.log("delegate")
                if (Obj.userid.S == global.$userid) {
                    //console.log("delegate")
                    if (Obj.status.S == "R") {
                        this.state.showtable = true;
                        newObj.id = Obj
                        newObj.begintime = Obj.begintime.S
                        newObj.endtime = Obj.endtime.S
                        newObj.ownerid = Obj.ownerid.S
                        newObj.ownername = Obj.ownername.S
                        newObj.meeting = Obj.meeting.S
                        tableObjs.push(newObj);
                    }
                }

            }
            if (tableObjs == "[]") {
                this.state.showtable = false;
            }
        }
        return tableObjs;
    }

    getAppointments() {
        let apiName = serviceNames.getAppointmentService();
        let path = ''; //replace this with the path you have configured on your API
        let myInit = {
            body:
            {
                'code': this.state.code,
                'command': 'getAllAppointments',
            },
            response: true,
            convertEmptyValues: true,
            headers: {}
        }
        //console.log(myInit);

        API.post(apiName, path, myInit).then(response => {
            //console.log ("response.data ===> " + response.data + "response.err ===> " + response.err);
            //console.log(response);

            if (response.err == null && response.data != null) {
                //console.log(response.data);
                var Appointments = this.getAppointmentTableObjects(response.data.Items);
                //console.log(Appointments);

                this.setState({
                    appointments: Appointments,
                    dataloaded: true
                });
            }
            else {
                ////console.log("getAttendeesTableObjects - failed!!");
                //console.log(response.err);
            }
        }
        ).catch(error => {
            //console.log(error.response)
        });

    }

}
export default AppointmentsList;


